import { useMutation } from '@tanstack/react-query';
import { serviceVendorsClient } from '@/services/petseo.service';
import type { ServiceVendorId, EmployeeId } from '@/services/api/petseo.client.wrapper';
import { TOAST_MESSAGES, toast } from '@petseo/shared';

export const useConnectGoogleCalendar = () => {
  return useMutation({
    mutationFn: async ({ serviceVendorId, employeeId }: { serviceVendorId: ServiceVendorId; employeeId: EmployeeId }) => {
      const response = await serviceVendorsClient.connectGoogleCalendarEndpoint(serviceVendorId, employeeId);
      return response.data;
    },
    onSuccess: (data) => {
      if (data.authorizationUrl) {
        window.location.href = data.authorizationUrl;
      }
    },
    onError: () => {
      toast.error(TOAST_MESSAGES.GOOGLE_CALENDAR_CONNECT_ERROR);
    },
  });
};
